/* Collection view switch (cards / table). docs/collection-table.md. The quantity stepper is assets/quick-add-qty.js.
   Delegated on the document: the grid is replaced when filters or sorting change, the bar and the component stay. */
(function () {
  var KEY = 'collection-view';

  function isTable() {
    var component = document.querySelector('collection-component');
    return !!component && component.getAttribute('data-view') === 'table';
  }

  function syncLabels() {
    var table = isTable();
    document.querySelectorAll('[data-view-toggle]').forEach(function (button) {
      var label = table ? button.getAttribute('data-label-cards') : button.getAttribute('data-label-table');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function setView(view) {
    document.querySelectorAll('collection-component').forEach(function (component) {
      if (view === 'table') component.setAttribute('data-view', 'table');
      else component.removeAttribute('data-view');
    });
    try {
      localStorage.setItem(KEY, view);
    } catch (e) {}
    syncLabels();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-view-toggle]');
    if (toggle) {
      setView(isTable() ? 'cards' : 'table');
      return;
    }

    /* Table view: the variant count opens the quick-add window instead of following the card's link */
    var variants = event.target.closest('.available-in__wrapper');
    if (variants && document.querySelector('collection-component[data-view="table"]')) {
      var open = variants.closest('.product-item').querySelector('.quick-add__holder:not(.mobile) [data-quick-add-btn]');
      if (open) {
        event.preventDefault();
        event.stopPropagation();
        open.click();
      }
      return;
    }
  });

  syncLabels();
})();
